import { Link } from 'react-router-dom';
import { ArrowRight, Server, CreditCard, FileText, Users, Radio } from 'lucide-react';

const productsList = [
  {
    id: 'mxcloud',
    icon: Server,
    title: 'MXCloud',
    description: 'A comprehensive Manufacturing Execution System (MES) built for modern production environments. Manage factory operations, track production metrics, and optimize manufacturing workflows.',
  },
  {
    id: 'lms',
    icon: CreditCard,
    title: 'Loan Management System (LMS)',
    description: 'End-to-end loan management solution for financial institutions. Handle loan origination, disbursement, repayment tracking, and portfolio management seamlessly.',
  },
  {
    id: 'invoicing',
    icon: FileText,
    title: 'E-Invoicing Software',
    description: 'GST-compliant electronic invoicing solution that automates invoice generation, validation, and submission. Streamline your billing operations with our intuitive platform.',
  },
  {
    id: 'hrms',
    icon: Users,
    title: 'HRMS',
    description: 'Complete Human Resource Management System covering employee lifecycle management, payroll processing, attendance tracking, and performance evaluation.',
  },
  {
    id: 'optics',
    icon: Radio,
    title: 'Fiber Optics',
    description: 'Advanced fiber optics solutions including Triple Play ONU+OTT, ONU+WIFI, OTT-Smart Android IPTV Box, and Outdoor WIFI systems for modern connectivity needs.',
  },
];

const ProductsPage = () => {
  return (
    <main>
      {/* Hero */}
      <section className="relative min-h-[50vh] flex items-center overflow-hidden">
        <div className="absolute inset-0 bg-surface" />
        <div className="absolute inset-0 hero-gradient" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 pt-32 pb-16 w-full">
          <p className="text-xs font-mono uppercase tracking-[0.3em] text-amber mb-4">Our Solutions</p>
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-white tracking-tight" data-testid="products-page-title">
            Products
          </h1>
          <p className="text-slate-300 mt-4 max-w-xl">
            Enterprise-grade products designed to solve complex business challenges.
          </p>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {productsList.map((product) => {
              const Icon = product.icon;
              return (
                <div
                  key={product.id}
                  id={product.id}
                  className="bg-surface border border-white/10 rounded-sm p-8 card-hover group"
                  data-testid={`product-${product.id}`}
                >
                  <div className="flex items-start gap-6">
                    <div className="w-14 h-14 bg-amber/10 rounded-sm flex items-center justify-center flex-shrink-0 group-hover:bg-amber/20 transition-colors">
                      <Icon className="w-7 h-7 text-amber" />
                    </div>
                    <div>
                      <h3 className="font-heading text-xl font-bold text-white mb-3">{product.title}</h3>
                      <p className="text-sm text-slate-400 leading-relaxed mb-4">{product.description}</p>
                      <Link to="/contact" className="text-amber text-sm font-medium inline-flex items-center gap-1 hover:gap-2 transition-all">
                        Learn More <ArrowRight className="w-3.5 h-3.5" />
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </main>
  );
};

export default ProductsPage;
